import React from "react"
import { graphql } from "gatsby"
import Image from "gatsby-image"
import styled from "styled-components"

import Layout from "../components/Layout"
import SEO from "../components/Seo"
import Button from "../components/Button"
import Container from "../components/Container"
import { brandViolet } from "../styles/colors"

const Title = styled.h1`
  font-size: 2em;
  color: ${brandViolet};
  display: flex;
  justify-content: center;
  font-family: "Open Sans", sans-serif;
  padding: 0 0 30px;
`

const Photo = styled(Image)`
  border-radius: 4px;
  align-self: center;
`

const TwoSections = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`

const Text = styled.div`
  flex: 2;
  font-family: "Open Sans", sans-serif;
  font-size: 1.1em;
  line-height: 1.5em;
  @media (min-width: 768px) {
    padding: 0 30px 30px 0;
  }

  a {
    color: ${brandViolet};
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 30px 0;
`;

const SubTitle = styled.h2`
  font-weight: bold;
  color: ${brandViolet};
  font-size: 1.3em;
  margin-bottom: 0;
`

const Right = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 30px;
  line-height: 1.7em;
`

const End = styled.div`
  padding-bottom: 50px;
`

const Newsletter = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title

  return (
    <>
      <Layout location={location} title={siteTitle} light={true}>
        <SEO 
          title="Newsletter" 
          img={data.newsletterImg.childImageSharp.fixed.src} 
          description="Naucz się front-endu z kernelgonnapanic 💻  Praktyczna nauka JSa, tworzenia aplikacji webowych i ciekawe historie z IT."
        />
        <Container>
          <Title>Naucz się front-endu z kernelgonnapanic 💻</Title>
          <TwoSections>
            <Text>
            Cześć! 
            <p> Mam na imię <strong>Ania</strong>, a w internecie występuję jako <strong>kernelgonnapanic</strong>. Moja przygoda z programowaniem front-end rozpoczęła się 6 lat temu. W 2015 roku w swoim notesie zapisałam cel: </p>
            <p>
            <i>"W tym roku rozpocznę pracę jako programistka front-end". </i>
            </p>
            <p>
            Tamtego roku przerobiłam sporo kursów online, stworzyłam swoją pierwszą aplikację w AngularJS, zostałam przyjęta na staż, a potem na stanowisko juniorskie. Osiągnęłam swój cel ❤️
            </p>
            
            <p>Dziś pomagam osiągnąć podobne cele prowadząc <a href="https://kernelgonnapanic.pl/konsultacje">indywidualne zajęcia z front-endu</a>. Współpracuję z osobami, które wchodzą do branży IT, ale również tymi, którzy chcą w niej rozwinąć skrzydła i wejść na wyższy poziom. Uczymy się różnych technologii od praktycznej strony i ćwiczymy kompetencje, które przydają się każdego dnia w pracy.</p>
            <ButtonWrapper>
              <Button size="big" onClick={() => window.ml_account('webforms', '3322018', 'i4q7p9', 'show')}>Zapisz mnie na newsletter &gt;&gt;</Button>
            </ButtonWrapper>
            <p>
            Czy masz czasem tak, że uczysz się z różnych materiałów, za Tobą już nie jeden kurs, temat wydaje Ci się zrozumiały, ale gdy siadasz przed białą kartką i masz napisać własny fragment kodu to masz wrażenie, że nic nie wiesz? 
            </p>
            <p>
            Czy nie możesz się odnaleźć w gąszczu różnych materiałów czy nowych technologii, które czekają na poznanie?
            </p>
            <p>
            A może pracujesz jako programistka lub programista front-end i chcesz po prostu umieć więcej? 
            </p>
            <p>
              W tym newsletterze znajdziesz <strong>cotygodniową dawkę informacji, zadań i pomysłów na Twój rozwój jako front-end developer</strong>. Będzie inspirująco, motywująco, ale też bardzo konkretnie i z uśmiechem. Dodatkowo zamierzam dzielić się swoimi osobistymi doświadczeniami i historiami z IT, codziennością pracy programistki i prowadzenia biznesu. Subskrybenci newslettera mogą także liczyć na informacje z pierwszej ręki o wypuszczanych przez mnie produktach (i kuponach rabatowych 😉).
            </p>
            <p>
              A jeśli jeszcze Cię nie przekonałam do dołączenia do mojego newslettera to wiedz, że przywita Cię w moim mailingu <strong>lista darmowych i godnych uwagi źródeł do nauki front-endu</strong> (zarówno dla dopiero zaczynających, jak i zaawansowanych).
            </p>
            <p>
              Mam nadzieję, że niedługo się widzimy!
            </p>
            <p>
              Do zobaczenia,
              <br/>
              Ania z kernelgonnapanic.pl
            </p>

            </Text>
            <Right>
              <Photo fixed={data.logo.childImageSharp.fixed} />
              <SubTitle>Tematyka:</SubTitle>
              <ul>
                <li>technologie front-endowe: HTML, CSS, JavaScript, React, TypeScript </li>
                <li>praktyczne zadania i projekty do wykonania </li>
                <li>codzienność pracy programistki </li>
                <li>moje przemyślenia o IT, front-endzie i prowadzeniu biznesu</li>
                <li>informacje o tworzonych przeze mnie produktach</li>
              </ul>
            </Right>
          </TwoSections>
          <End>
            <Button size="big" onClick={() => window.ml_account('webforms', '3322018', 'i4q7p9', 'show')}>Zapisz mnie na newsletter &gt;&gt;</Button>
          </End>
        </Container>
      </Layout>
    </>
  )
}

export default Newsletter

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    logo: file(absolutePath: { regex: "/assets/ja.jpg/" }) {
      childImageSharp {
        fixed(width: 350) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    newsletterImg: file(absolutePath: { regex: "/assets/newsletter.png/" }) {
      childImageSharp {
        fixed {
          src
        }
      }
    }
  }
`
